app.config(function ($translateProvider) {
    $translateProvider.translations('nl', {
        STATUS_ACTIVE: 'Actief',
        STATUS_INACTIVE: 'Niet actief',
        STATUS_DRAFT: 'Concept',
        STATUS_TRAINING: 'Training'
    });
});
